import { FGCheckboxInput, FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";
import * as Yup from "yup";

import { CountryTranslationDto, LanguageApi, LanguageDto, LanguageTranslationDto } from "../../../../api";
import { FGMultiTranslate, PageBase, SmallFormGenerator } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { ERoutes } from "../../../../ERoutes";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";

export interface ILanguageDetailPageProps {
  languageId: number;
  edit: boolean;
}

export const LanguageDetailPage: React.FunctionComponent<ILanguageDetailPageProps> = ({ languageId, edit }) => {
  const { t } = useTl();
  const api = useApiService(LanguageApi);
  const history = useHistory();

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      languageCode: Yup.string().required(t(ETLCodes.Required)),
    });
  }, [api, t]);

  const { data, loading, deleteItem, deleting, saveItem, saving, refresh } = useCrudApi(
    {
      getApiFn: (id = languageId) =>
        id > 0
          ? api.getByLanguageId(id)
          : LanguageDto.fromJS({ hasTranslation: false, languageTranslations: [] }).toJSON(),
      saveApiFn: (d: LanguageDto) => api.save(d),
      onSavedRoute: (d) => `${ERoutes.language}/${d.languageId}/detail/edit`,
      deleteApiFn: (d) => api.deleteLanguage(d.languageId),
      onDeletedRoute: () => ERoutes.language,
    },
    []
  );
  return (
    <SmallFormGenerator
      initialValues={data}
      onSubmit={saveItem}
      editMode={edit}
      validationSchema={FormSchema}
      loading={loading}
      onCancel={() => history.push(ERoutes.language)}
      onDelete={deleteItem}
      showDeleteButton={languageId > 0}
      saving={saving}
      deleting={deleting}
    >
      <FieldGroup columns={2}>
        <FieldGroup>
          <FGMultiTranslate
            label={ETLCodes.Name}
            translationsArrayField="languageTranslations"
            translationField="text"
            translationDto={LanguageTranslationDto}
            languageIdFieldName="translationLanguageId"
          />
        </FieldGroup>
        <FieldGroup>
          <FGTextInput name="languageCode" label={t(ETLCodes.Iso2Code)} />
          <FGTextInput name="bcLanguageCode" label={t(ETLCodes.BCLanguageCode)} readonly />
          <FGCheckboxInput readonly name="hasTranslation" label={t(ETLCodes.HasTranslation)} />
        </FieldGroup>
      </FieldGroup>
    </SmallFormGenerator>
  );
};
